<template>
  <div>
    <div class="modal-backdrop"></div>
    <div class="modal">
      <div class="modal-inner">
        <div class="custom-modal-header">
          <div class="title">
            <i class="fas fa-folder"></i>
            <span>Add Tag</span>
          </div>
          <div class="close-btn">
            <div class="btn-close" @click="$emit('closeModal', false)"></div>
          </div>
        </div>
        <div class="custom-modal-content">
          <div class="form-group">
            <label for="group-name">Flow Tags:</label>
            <p>Selected Tag:</p>
            <div class="custom-multiselect" :class="{ open: isListOpen }">
              <div class="custom-multiselect-wrap">
                <div class="custom-selected-tags">
                  <div class="custom-selected-tags-wrap">
                    <div
                      class="custom-selected-item selected-item"
                      v-for="(tag, index) in selectedTag"
                      :key="tag.tagName"
                      :style="{ 'background-color': tag.tagColor }"
                    >
                      <span>{{ tag.tagName }}</span>
                      <i class="fa fa-times" @click="removeTagList(index)"></i>
                    </div>
                    <div class="custom-selected-item input">
                      <input
                        type="text"
                        name="group-name"
                        ref="tagNameInput"
                        @focus="openList()"
                        v-model="searchTag"
                        @keyup="handelKeyEvent"
                      />
                    </div>
                  </div>
                </div>
                <div
                  class="custom-multiselect-list"
                  :class="{ open: isListOpen }"
                >
                  <div class="custom-multiselect-list-wrap">
                    <div
                      class="custom-multiselect-list-item"
                      v-if="isNewTag"
                      @click="openColorsList()"
                    >
                      <div class="custom-multiselect-list-item-inner">
                        <span class="tag-name"> Create Tag </span>
                      </div>
                    </div>
                    <div
                      v-if="isColorsListOpen"
                      class="custom-multiselect-list-item"
                    >
                      <div class="custom-multiselect-list-item-inner">
                        <div class="colors-tags-list-wrapper">
                          <div
                            class="colors-Tag-list-item"
                            v-for="colorName in tagColorsList"
                            :style="{ 'background-color': colorName }"
                            :key="colorName"
                            @click="createNewTag(colorName)"
                          ></div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="custom-multiselect-list-item"
                      v-for="(tag, tagIndex) in tagList"
                      :key="tag.tagName"
                      @click="selectTag(tagIndex)"
                    >
                      <div class="custom-multiselect-list-item-inner">
                        <span
                          class=""
                          :style="{ 'background-color': tag.tagColor }"
                        >
                          {{ tag.tagName }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="custom-modal-footer">
          <div class="footer-wrap">
            <div>
              <button class="btn save-button" @click="saveTagsInFlow">
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchTag: '',
      selectedTag: [],
      tagColorsList: [
        '#f07067',
        '#fdff82',
        '#a4f582',
        '#82f1f5',
        '#8297f5',
        '#b2b1b5',
      ],
      isListOpen: false,
      isNewTag: false,
      isColorsListOpen: false,
      tags: null,
    };
  },
  props: {
    tagList: Array,
    processList: Array,
    flowId: Number,
    idx: Number,
  },
  methods: {
    saveTagsInFlow() {
      this.$refs.tagNameInput.focus();
      const obj = this.$store.state.flows.find((item) => {
        if (item.id === this.flowId) {
          return item;
        }
      });
      this.selectedTag.map((item) => {
        obj.tags.push(item);
      });
      this.$emit('closeModal', false);
      this.selectedTag = [];
    },
    handelKeyEvent() {
      if (this.searchTag !== '' && this.searchTag !== ',') {
        this.searchTag = this.searchTag.replace(/,/g, '').trim();
        const isStringExistInTagList = this.tagList.some(
          (tagItem) =>
            tagItem.tagName.toLowerCase() == this.searchTag.toLowerCase()
        );
        const isStringExistInSelectedList = this.selectedTag.some(
          (tagItem) =>
            tagItem.tagName.toLowerCase() == this.searchTag.toLowerCase()
        );
        if (!isStringExistInTagList && !isStringExistInSelectedList) {
          this.isColorsListOpen = false;
          this.isNewTag = true;
        } else {
          this.isNewTag = false;
          this.isColorsListOpen = false;
        }
      }
      if (this.searchTag === '') {
        this.isNewTag = false;
        this.isColorsListOpen = false;
      }
    },
    async createNewTag(colorName) {
      this.$refs.tagNameInput.focus();
      if (this.searchTag !== '' && colorName != '') {
        this.searchTag = this.searchTag.replace(/,/g, '').trim();
        this.selectedTag.push({
          tagName: this.searchTag,
          tagColor: colorName,
        });
      }
      this.isColorsListOpen = false;
      this.searchTag = '';
    },
    async selectTag(tagIndex) {
      this.selectedTag.push(this.tagList[tagIndex]);
      this.tagList.splice(tagIndex, 1);
      this.$refs.tagNameInput.focus();
    },
    openList() {
      this.$refs.tagNameInput.focus();
      this.isListOpen = true;
    },
    openColorsList() {
      this.$refs.tagNameInput.focus();
      this.isNewTag = false;
      this.isColorsListOpen = true;
    },
    removeTagList(tagIndex) {
      this.$refs.tagNameInput.focus();
      this.tagList.push(this.selectedTag[tagIndex]);
      this.selectedTag.splice(tagIndex, 1);
    },
  },
};
</script>
<style scoped>
@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';

.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  padding: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  border-radius: 10px;
  display: block;
}
.modal .modal-inner {
  width: 50%;
  height: auto;
  background: #fff;
  padding: 25px 40px 40px 43px;
  border-radius: 10px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  margin: 0 auto;
}
.modal .btn-close {
  position: absolute;
  right: 0;
  top: 0;
}
.custom-modal-header {
  border-bottom: 1px solid #eee;
  box-sizing: border-box;
  display: block;
  position: relative;
  padding-bottom: 10px;
}
.modal .btn-close:focus {
  outline: none;
  box-shadow: none;
}

.custom-modal-header .title {
  font-size: 22px;
  color: #525252;
  float: none;
  margin-right: 0;
  padding-right: 0;
}

.custom-modal-header .title i {
  margin-right: 20px;
}
.custom-modal-footer {
  padding-top: 10px;
  border-top: 1px solid #eee;
}

.custom-modal-footer .footer-wrap {
  display: flex;
  justify-content: space-between;
  float: right;
}

.custom-modal-footer .footer-wrap button {
  min-width: 100px;
  background-color: #191f25;
  color: #fff;
}
.custom-modal-content {
  min-height: 150px;
  margin: 20px 0;
}
.form-item input {
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 8px 15px;
  width: 100%;
  height: auto;
  /* max-width: 250px; */
  box-sizing: border-box;
}

.form-group {
  margin-bottom: 20px;
}

/*Custom select*/
.custom-multiselect {
  position: relative;
  box-sizing: border-box;
  margin-top: 3px;
}

.custom-multiselect.open {
  box-shadow: 0 0 0 1px rgb(0 0 0 / 5%), 0 10px 20px rgb(0 0 0 / 15%);
  border-radius: 4px;
  overflow: hidden;
}

.custom-multiselect .custom-multiselect-list {
  padding: 6px 0;
  background: #fff;
  display: none;
  max-height: 300px;
  overflow-y: auto;
}

.custom-multiselect .custom-multiselect-list.open {
  display: block;
}

.custom-multiselect .custom-multiselect-wrap {
  display: flex;
  flex-direction: column;
  min-width: 180px;
  max-width: calc(100vw - 24px);
  height: 100%;
  max-height: 70vh;
}

.custom-multiselect * {
  box-sizing: border-box;
}

.custom-multiselect .custom-selected-tags {
  max-height: 240px;
  box-shadow: rgb(55 53 47 / 16%) 0px -1px inset;
  z-index: 1;
  overflow: hidden auto;
  margin-right: 0px;
  margin-bottom: 0px;
}
.custom-multiselect .custom-selected-tags-wrap {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  cursor: text;
  overflow: auto;
  width: 100%;
  font-size: 14px;
  margin-right: 0px;
  margin-bottom: 0px;
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 8px 15px;
}

.custom-multiselect .custom-selected-item {
  display: flex;
  align-items: center;
  flex-shrink: 1;
  min-width: 0px;
  height: 20px;
  border-radius: 3px;
  padding-left: 6px;
  padding-right: 0px;
  font-size: 14px;
  line-height: 120%;
  margin: 0px 6px 0 0px;
}

.custom-multiselect .custom-selected-item span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
}

.custom-multiselect .custom-selected-item i {
  user-select: none;
  transition: background 20ms ease-in 0s;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 0;
  flex-shrink: 0;
  margin-left: 2px;
  margin-right: 2px;
  width: 20px;
  height: 20px;
}
.custom-multiselect .custom-selected-item.input,
.custom-multiselect .custom-selected-item.input input {
  background: #fff !important;
  outline: none;
}

.custom-multiselect .custom-selected-item.input input {
  font-size: inherit;
  line-height: inherit;
  border: none;
  background: none;
  width: 100%;
  display: block;
  resize: none;
  padding: 0px;
  height: 18px;
  margin-bottom: 0;
  cursor: text;
}

.custom-multiselect .custom-selected-item.input {
  display: flex;
  align-items: center;
  border: none;
  padding: 0px;
  width: auto;
  background: transparent;
  font-size: inherit;
  line-height: 20px;
  flex: 1 1 60px;
  min-width: 60px;
  margin: 0px 6px 0 0px;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.custom-multiselect .custom-multiselect-list-item {
  display: flex;
  flex-direction: column;
  padding: 0 15px;
  cursor: pointer;
  transition: all 300ms ease-in-out;
}
.custom-multiselect-list-item:hover {
  background: #f0f0f0;
}
.custom-multiselect .custom-multiselect-list-item-inner {
  text-transform: uppercase;
  font-weight: 500;
  margin-bottom: 8px;
  margin-top: 8px;
  font-size: 14px;
}
.custom-multiselect .custom-multiselect-list-item-inner span {
  padding: 2px 8px;
  border-radius: 4px;
}

.colors-tags-list-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
}
.colors-Tag-list-item {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  position: relative;
  margin-right: 10px;
  margin-bottom: 4px;
  margin-top: 4px;
}
.colors-Tag-list-item:before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: calc(100% + 3px);
  height: calc(100% + 3px);
  border-radius: 50%;
  border: 1px solid transparent;
  transition: 0.5s;
}
.colors-Tag-list-item:hover:before {
  border: 1px solid grey;
}
.colors-Tag-list-item.active:before {
  border: 1px solid black;
}
/* custom select end */
</style>
